<div class="loading-overlay">
  <div class="loading-content">
    <img [src]="logoPath()" alt="Dhofar Logo" class="loading-logo" />
  </div>
</div>
